"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Columns = void 0;
const react_1 = __importDefault(require("react"));
const Columns = ({ children, className = 'col-12', ...props }) => {
    return react_1.default.createElement("div", { className: className, ...props }, children);
};
exports.Columns = Columns;
